// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"78890740","6912":"e22a5728","8603":"f3c1a26e","9574":"b443969a"}[chunkId] + ".chunk.css";
};